import "./App.css"; //npm run build to build
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";

import React, { useEffect, useState } from "react";

import { Suspense, lazy } from "react";

import { Provider } from "react-redux";

import { useDispatch, useSelector } from "react-redux";

import store from "./store";
import ReactGA from "react-ga4";

import { useLocation } from "react-router-dom";
import LoadingPage from "./pages/Loading/Loading";
import {
  post_to_server,
  update_status,
  get_user,
} from "./network/communication.js";
import { HelmetProvider } from "react-helmet-async";
import QuizExam from "./pages/QuizExam/QuizExam";
import QuizFinished from "./pages/QuizFinished/QuizFinished";

import "react-range-slider-input/dist/style.css";
import SupportSection from "./pages/SupportSection/SupportSection";
import SupportArticle from "./pages/SupportArticle/SupportArticle";
import WriteSupportArticle from "./pages/WriteSupportArticle/WriteSupportArticle";
import CookieBanner from "./components/CookieBanner/CookieBanner";
import { LoadingContext } from "./contexts/LoadingContext";
import { UserProvider } from "./contexts/UserProvider";
import WriteBlogArticle from "./pages/WriteBlogArticle/WriteBlogArticle";
import { FlipcardStateProvider } from "./components/FlipCard/FlipcardStateContext.jsx";

const Index = lazy(() => import("./pages/Index/Index"));
const VerifyEmail = lazy(() => import("./pages/VerifyEmail/VerifyEmail"));
const VerifyEmailSuccess = lazy(() =>
  import("./pages/VerifyEmailSuccess/VerifyEmailSuccess")
);
const Blog = lazy(() => import("./pages/Blog/Blog"));
const BlogSubsection = lazy(() =>
  import("./pages/BlogSubsection/BlogSubsection")
);
const BlogArticle = lazy(() => import("./pages/BlogArticle/BlogArticle"));
const Dashboard = lazy(() => import("./pages/Dashboard/Dashboard"));
const Dashboard_Study = lazy(() =>
  import("./pages/Dashboard-Study/Dashboard-Study")
);
const Dashboard_Friends = lazy(() =>
  import("./pages/Dashboard-Friends/Dashboard-Friends")
);
const Dashboard_Changelog = lazy(() =>
  import("./pages/Dashboard-Changelog/Dashboard-Changelog")
);
const Dashboard_Payments = lazy(() =>
  import("./pages/Dashboard-Payments/Dashboard-Payments")
);
const Dashboard_Settings = lazy(() =>
  import("./pages/Dashboard-Settings/Dashboard-Settings")
);
const Dashboard_Settings_Privacy = lazy(() =>
  import("./pages/Dashboard-Settings-Privacy/Dashboard-Settings-privacy")
);
const Dashboard_Settings_Notifications = lazy(() =>
  import(
    "./pages/Dashboard-Settings-Notifications/Dashboard-Settings-Notifications"
  )
);
const Header = lazy(() => import("./components/Header/Header"));
const Footer = lazy(() => import("./components/Footer/Footer"));

const Upgrade = lazy(() => import("./pages/Upgrade/Upgrade"));

const AboutUs = lazy(() => import("./pages/AboutUs/AboutUs"));
const Create = lazy(() => import("./pages/Create/Create"));

ReactGA.initialize("G-NF57LYGCJP");

const ThanksForPurchase = lazy(() =>
  import("./pages/ThanksForPurchase/ThanksForPurchase")
);
const ForgotPassword = lazy(() =>
  import("./pages/ForgotPassword/ForgotPassword")
);
const ResetPassword = lazy(() => import("./pages/ResetPassword/ResetPassword"));
const Login = lazy(() => import("./pages/Login/Login"));
const Signup = lazy(() => import("./pages/Signup/Signup"));
const Study = lazy(() => import("./pages/Study/Study"));
const Recall = lazy(() => import("./pages/Recall/Recall"));
const RecallResults = lazy(() => import("./pages/RecallResults/RecallResults"));

const Support = lazy(() => import("./pages/Support/Support"));

const NotFound = lazy(() => import("./pages/NotFound/NotFound"));
const Subject = lazy(() => import("./pages/Subject/Subject"));
const User = lazy(() => import("./pages/User/User"));
const User_Friends = lazy(() => import("./pages/User-Friends/User-Friends"));
const User_Sets = lazy(() => import("./pages/User-Sets/User-Sets"));

const Discover = lazy(() => import("./pages/Discover/Discover"));

const Search = lazy(() => import("./pages/Search/Search"));

function App() {
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState({
    name: "",
    success: false,
    schedule: [],
    recent_schedule: [],
    friends: {},
    streak: 0,
    today: {
      most_difficult_terms: {},
      pending: 0,
      completed: 0,
      std: {},
      study_time: 0,
      streak_saved: 0,
    },
    streak_calendar: { this_month: [] },
    email_verified: true,
  });

  const useEmailVerification = (user) => {
    const navigate = useNavigate();

    useEffect(() => {
      if (user && user.success === true) {
        if (!user.email_verified) {
          navigate("/verify-email");
        }
      }
    }, [user, navigate]);
  };

  useEffect(() => {
    get_user(function (user) {
      if (user && user.success === true) {
        setUser(user);
      }
    });
  }, []);

  const [isBannerVisible, setIsBannerVisible] = useState(true);

  useEffect(() => {
    update_status("online");
    // No need for this, since we're doing it via CRON
    /*window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      update_status("offline");
    });*/
  }, []);

  return (
    <HelmetProvider>
      <Provider store={store}>
        <Router>
          <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
            <Suspense fallback={<LoadingPage />}>
              <Header user={user} setUser={setUser} />
              <CookieBanner
                user={user}
                setUser={setUser}
                isVisible={isBannerVisible}
                setVisibility={setIsBannerVisible}
              ></CookieBanner>
              <Routes>
                <Route
                  index
                  element={<Index user={user} setUser={setUser} />}
                />
                <Route
                  path="/verify-email"
                  element={<VerifyEmail user={user} setUser={setUser} />}
                />
                <Route
                  path="/verify-email-success"
                  element={<VerifyEmailSuccess user={user} setUser={setUser} />}
                />
                <Route
                  path="/about-us"
                  element={<AboutUs user={user} setUser={setUser} />}
                />
                <Route
                  path="/create"
                  element={<Create user={user} setUser={setUser} />}
                />
                <Route
                  path="/dashboard"
                  element={<Dashboard user={user} setUser={setUser} />}
                />
                <Route
                  path="/discover"
                  element={<Discover user={user} setUser={setUser} />}
                />
                <Route
                  path="/dashboard/study"
                  element={<Dashboard_Study user={user} setUser={setUser} />}
                />
                <Route
                  path="/dashboard/friends"
                  element={<Dashboard_Friends user={user} setUser={setUser} />}
                />
                <Route
                  path="/dashboard/changelog"
                  element={
                    <Dashboard_Changelog user={user} setUser={setUser} />
                  }
                />
                <Route
                  path="/dashboard/payments"
                  element={<Dashboard_Payments user={user} setUser={setUser} />}
                />
                <Route
                  path="/dashboard/settings/profile"
                  element={<Dashboard_Settings user={user} setUser={setUser} />}
                />
                <Route
                  path="/dashboard/settings/privacy"
                  element={
                    <Dashboard_Settings_Privacy user={user} setUser={setUser} />
                  }
                />
                <Route
                  path="/dashboard/settings/notifications"
                  element={
                    <Dashboard_Settings_Notifications
                      user={user}
                      setUser={setUser}
                    />
                  }
                />

                <Route
                  path="/thanks-for-purchase"
                  element={<ThanksForPurchase user={user} setUser={setUser} />}
                />
                <Route
                  path="/upgrade"
                  element={<Upgrade user={user} setUser={setUser} />}
                />

                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route
                  path="/quiz-exam"
                  element={<QuizExam user={user} setUser={setUser} />}
                />
                <Route path="/quiz-finished" element={<QuizFinished />} />
                <Route path="/blog" element={<Blog user={user} />} />
                <Route
                  path="/blog/sections/:section"
                  element={<BlogSubsection user={user}></BlogSubsection>}
                ></Route>
                <Route
                  path="/blog/sections/:section/:id/:article"
                  element={<BlogArticle />}
                />
                <Route
                  path="/blog/write"
                  element={<WriteBlogArticle user={user} setUser={setUser} />}
                />
                <Route path="/support" element={<Support />} />
                <Route
                  path="/support/write"
                  element={
                    <WriteSupportArticle user={user} setUser={setUser} />
                  }
                />
                <Route
                  path="/support/sections/:section"
                  element={<SupportSection />}
                />
                <Route
                  path="/support/sections/:section/:id/:article"
                  element={<SupportArticle />}
                />

                <Route
                  path="/search/:query"
                  element={<Search user={user} setUser={setUser} />}
                />

                <Route
                  path="/study/:setid/:title"
                  element={
                    <FlipcardStateProvider>
                      <Study user={user} setUser={setUser} />
                    </FlipcardStateProvider>
                  }
                />

                <Route
                  path="/study/:setid/:title/recall"
                  element={<Recall user={user} setUser={setUser} />}
                />
                <Route
                  path="/study/:setid/:title/recall/results"
                  element={<RecallResults user={user} setUser={setUser} />}
                />
                <Route
                  path="/study/:setid/:title/quiz"
                  element={<QuizExam user={user} setUser={setUser} />}
                />
                <Route
                  path="/study/:setid/:title/quiz/:id/results"
                  element={<QuizExam user={user} setUser={setUser} />}
                />
                <Route
                  path="/study/:setid/:title/edit"
                  element={<Create user={user} setUser={setUser} edit={true} />}
                />
                <Route path="/subjects/:subject" element={<Subject />} />
                <Route
                  path="/users/:userid"
                  element={<User me={user} setUser={setUser} />}
                />
                <Route
                  path="/users/:userid/friends"
                  element={<User_Friends me={user} setUser={setUser} />}
                />
                <Route
                  path="/users/:userid/sets"
                  element={<User_Sets me={user} setUser={setUser} />}
                />
                {/*<Route path="/jobs" element={<Jobs />} />*/}
                <Route path="/*" element={<Navigate to="/404" />} />
                <Route path="/404" element={<NotFound />} />
              </Routes>
              <Footer
                user={user}
                setUser={setUser}
                setBannerVisibility={setIsBannerVisible}
              />
            </Suspense>
          </LoadingContext.Provider>
        </Router>
      </Provider>
    </HelmetProvider>
  );
}

export default App;
